"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const styles_1 = require("@material-ui/core/styles");
const _1 = require("./");
const core_1 = require("@material-ui/core");
const ThemeWrapper = (props) => {
    const { children } = props;
    return (react_1.default.createElement(styles_1.ThemeProvider, { theme: _1.theme },
        react_1.default.createElement(core_1.CssBaseline, null),
        children));
};
ThemeWrapper.propTypes = {
    children: prop_types_1.default.any.isRequired,
};
exports.default = ThemeWrapper;
